import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";
import { Sparkles } from "lucide-react";
import { LANDING } from "@/constants/testIds";
import { trackClick } from "@/lib/track";

const StickyMobileCTA = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      setVisible(window.scrollY > window.innerHeight * 0.6);
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <AnimatePresence>
      {visible ? (
        <motion.div
          initial={{ y: "110%" }}
          animate={{ y: 0 }}
          exit={{ y: "110%" }}
          transition={{ duration: 0.35, ease: [0.22, 1, 0.36, 1] }}
          className="fixed inset-x-0 bottom-0 z-50 border-t border-line bg-night-950/92 p-3 backdrop-blur-xl md:hidden"
        >
          <Link
            data-testid={LANDING.stickyMobileCta}
            to="/chat"
            onClick={() => trackClick("chat")}
            className="inline-flex w-full items-center justify-center gap-2 rounded-full bg-amber px-6 py-3.5 text-base font-semibold text-night-900 shadow-glow transition-transform active:scale-95"
          >
            <Sparkles className="h-4 w-4" />
            Сделать сказку бесплатно
          </Link>
        </motion.div>
      ) : null}
    </AnimatePresence>
  );
};

export default StickyMobileCTA;
